import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "overflow-hide" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center flex-wrap" }
const _hoisted_3 = {
  class: "d-flex flex-wrap py-2 mr-3",
  dir: "ltr"
}
const _hoisted_4 = { class: "d-flex align-items-center py-3" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2 text-muted" }, "loading...", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "spinner mr-10" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_pagination = _resolveComponent("n-pagination")!
  const _component_a_btn_sm = _resolveComponent("a-btn-sm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.Pager && _ctx.paginateModel.currentPage != 0 && !_ctx.disablePager)
          ? (_openBlock(), _createBlock(_component_n_pagination, {
              key: 0,
              size: "large",
              page: _ctx.paginateModel.currentPage,
              "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paginateModel.currentPage) = $event)),
              "page-count": _ctx.paginateModel.totalPages,
              "page-size": _ctx.paginateModel.pageSize,
              "page-slot": 5,
              "show-size-picker": "",
              "on-update:page-size": _ctx.SetPageSize,
              "on-update:page": _ctx.PageTo,
              "page-sizes": _ctx.options
            }, null, 8, ["page", "page-count", "page-size", "on-update:page-size", "on-update:page", "page-sizes"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_ctx.btnAddTo)
          ? (_openBlock(), _createBlock(_component_a_btn_sm, {
              key: 0,
              to: _ctx.btnAddTo,
              text: _ctx.btnAddLable,
              icon: "fa fa-plus",
              color: "primary"
            }, null, 8, ["to", "text"]))
          : _createCommentVNode("", true),
        (_ctx.ModalNew)
          ? (_openBlock(), _createBlock(_component_a_btn_sm, {
              key: 1,
              onClick: _ctx.OpenModal,
              text: _ctx.btnAddLable,
              icon: "fa fa-plus",
              color: "primary"
            }, null, 8, ["onClick", "text"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}